import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class AdministrationService { 
  constructor(private http: HttpClient) {
  }
 
  save(saveData): Observable<any> {
    return this.http.post(CommonConstants.ADMINISTRATION_SAVE, saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getAdministratorById(phamaId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/administrator/' + phamaId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  errorHandler(error: any): void {
    throwError(error);
  };

  searchAdministrators(data, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/administrator' + '?start=' + startIndex + '&size='
      + CommonConstants.PAGINATION_SIZE, data)
  }
}
